import Wizard from 'scoreboard/components/wizard'
import DemoDataOrgs from './demo-data-orgs'
import DemoDataOptions from './demo-data-options'

var views = [DemoDataOrgs, DemoDataOptions]

var DemoDataWizard = Wizard.extend({

	initialize: function() {
		Wizard.prototype.initialize.call(this, { views: views })
	},

	saveState: function(demoData) {
		this.options.demoData = demoData
	}

})

export default DemoDataWizard


DemoDataWizard.__filename__ = 'admin/demo-data/demo-data-wizard.js'
